<template>
  <div class="top">
    <div class="top_logo">
      <router-link to="/">
        <img src="../assets/jsczt_logo.png" />
      </router-link>
    </div>
    <div class="top_title">
      江苏省预决算公开统一平台
    </div>
    <div class="searchBox">
         <div class="searchcont">
            <div class="searchinput">
              <el-input v-model="searchinput" clearable placeholder="请输入搜索内容"></el-input>
            </div>
            <div class="gobtn" @click="gotoSearch()">
              搜索
            </div>
         </div>
      </div>
    <div class="top_tab">
      <li>
        <a
          v-for="tab in tabs"
          :key="tab.id"
          :class="{ active: activeTab === tab.path }"
          @click="goto(tab)"
          >{{ tab.name }}</a
        >
      </li>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top',
  data () {
    return {
      activeTab: '',
      searchinput: '',
      tabs: [
        { path: 'overView', name: '预决算公开管理文件', id: '6' },
        { path: 'overView2', name: '政府预决算公开', id: '9' },
        { path: 'overViews', name: '部门预决算公开', id: '26' }
      ],
      data: {},
      storageData: {}
    }
  },
  mounted () {
  },
  methods: {
    gotoSearch () {
      var url = 'http://yjsgk.jsczt.cn/was5/web/search?channelid=234439&orderby=RELEVANCE&perpage=&searchword=' + this.searchinput
      window.open(url, '_blankk')
    },
    async goto (item) {
      this.activeTab = item.path
      this.data.classinfoid = item.id
      this.storageData = JSON.parse(localStorage.getItem('key'))
      if (this.storageData) {
        this.data.year = this.storageData.year
        this.data.code = this.storageData.code
        this.data.parentid = this.storageData.parentid
      }
      localStorage.setItem('topcname', item.name)
      try {
        await this.$router.push({ name: item.path, query: { ...this.data } })
      } catch (err) {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
    }
  },
  watch: {
    '$route': {
      handler (val) {
        this.data = this.$route.query
        this.storageData = JSON.parse(localStorage.getItem('key'))
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.activeTab = this.$route.name || 'overView'
    if (this.$route.name === 'overViewt') {
      this.activeTab = 'overViews'
    }
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
.top {
  position: relative;
  /* width: 1920PX; */
  height: 260PX;
  background: url(../assets/top.png) no-repeat;
  background-size: cover;
  margin: 0 auto
}
.top_logo {
  padding-top: 15PX;
  margin-left: 155PX;
}
.top_title {
  width: 578PX;
  height: 45PX;
  font-size: 48PX;
  font-weight: 400;
  color: #fefefe;
  line-height: 85PX;
  margin: 0 auto;
}
.top_tab {
  width: 720PX;
  margin: 0 auto;
  margin-top: 60PX;
}
.top_tab li {
  display: inline-block;
}
.top_tab li a {
  display: inline-block;
  width: 219PX;
  height: 40PX;
  background: #1e5a96;
  border: 1PX solid #4f88c1;
  border-radius: 10PX;
  text-align: center;
  font-size: 20PX;
  font-weight: 400;
  color: #fff;
  line-height: 38PX;
  margin-left: 15PX;
  cursor: pointer;
}
.active {
  background: #f7fafd !important;
  color: #245d94 !important;
}

.searchBox {
  position: absolute;
  right: 40PX;
  top: 30PX;
}

.searchcont {
  position: relative;
  width: 340PX;
  height: 45PX;
}

.searchinput {
  width: 275PX;
  height: 41PX;
}

/deep/ .searchinput .el-input__inner {
  width: 275PX;
  height: 41PX;
  background: #FCFDFD;
  border: 1PX solid #9ABAD6;
  opacity: 0.74;
  border-radius: 10PX;
  font-size: 20PX;
  color: #5E93BF;
}
.searchBox .gobtn {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20PX;
  width: 55PX;
  height: 42PX;
  background-color: #0C84E3;
  color: #fff;
  border-radius: 10PX;
  text-align: center;
  line-height: 42PX;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue